import config from '@/lib/config';

/**
 * @param {Number} fte
 * @return {Number}
 */
export default function fteToHours(fte) {
  return config.FTE_HOURS_PER_WEEK * fte;
}
